<template>
  <p>
    <span v-if="value">{{ value }} {{ suffix }}</span>
    <span v-else class="mediumTwo--text">&mdash;</span>
  </p>
</template>

<script>
export default {
  props: {
    suffix: { type: String, default: null },
    value: { type: String, default: null }
  }
}
</script>
